import {
    TAgentsActions,
    LOAD_AGENTS_FOR_AGENCY,
    LOAD_AGENTS_FOR_AGENCY_SUCCESS,
    LOAD_AGENTS_FOR_AGENCY_FAILURE,
} from '../actions/Agents';
import { TAgent } from '../types';

type TState = {
    fetching: boolean;
    error: unknown;
    content: TAgent[];
};

const initialState: TState = {
    fetching: false,
    error: undefined,
    content: [],
};

const reducer = (state = initialState, action: TAgentsActions): TState => {
    switch (action.type) {
        case LOAD_AGENTS_FOR_AGENCY:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOAD_AGENTS_FOR_AGENCY_SUCCESS:
            return {
                ...state,
                content: action.payload,
                fetching: false,
            };
        case LOAD_AGENTS_FOR_AGENCY_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        default:
            return state;
    }
};

export default reducer;
